import API from '../../clients/api'
import UAA from '../../clients/uaa'
import { errorHandler } from '../helpers'

const uaaLogin = async formData => {
  const { email: username, password } = formData
  const postData = {
    username,
    password,
  }
  const route = `authenticate`
  return UAA.post(route, postData)
    .then(response => Promise.resolve(response.data.data))
    .catch(error => Promise.reject(errorHandler(error.response.data)))
}

const uaaFetchStatus = async () => {
  const route = `auth/status`
  return UAA.get(route)
    .then(response => Promise.resolve(response.data.data))
    .catch(error => Promise.reject(errorHandler(error.response.data)))
}

const uaaLogout = async () => {
  const route = `logout`
  return UAA.post(route, {})
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(errorHandler(error.response.data)))
}

const uaaPostMFACode = async code => {
  const route = `users/mfa/validate`
  return UAA.post(route, { code })
    .then(response => Promise.resolve(response.data.data))
    .catch(error => Promise.reject(errorHandler(error.response.data)))
}

const uaaResendMFACode = async () => {
  const route = `users/mfa/resend`
  return UAA.post(route, {})
    .then(response => Promise.resolve(response.data.data))
    .catch(error => Promise.reject(errorHandler(error.response.data)))
}

const uaaCreateAccount = async userSubmittedData => {
  const {
    firstName: first_name,
    lastName: last_name,
    email,
    password,
  } = userSubmittedData
  const postData = {
    first_name,
    last_name,
    email,
    password,
    origin: 'my.ine.com',
  }
  const route = `users`
  return UAA.post(route, postData)
    .then(response => Promise.resolve(response.data.data))
    .catch(error => Promise.reject(errorHandler(error.response.data)))
}

const uaaResetPassword = async email => {
  const route = `users/reset-password?email=${email}`
  return UAA.post(route, {})
    .then(response => Promise.resolve(response.data.data))
    .catch(error => Promise.reject(errorHandler(error.response.data)))
}

const uaaFetchAuthProviders = async () => {
  const route = `providers?referrer=my-ine`
  return UAA.get(route)
    .then(response => Promise.resolve(response.data.data))
    .catch(error => Promise.reject(errorHandler(error.response.data)))
}

const fetchUserId = async id => {
  const route = `users?customer_id=${id}`
  return API.get(route)
    .then(response => Promise.resolve(response.data.data[0].id))
    .catch(error => Promise.reject(errorHandler(error.response.data)))
}

const fetchUserIdForImpersonation = async email => {
  const route = `users?email_address=${email}`
  return API.get(route)
    .then(response => Promise.resolve(response.data.data[0].id))
    .catch(error => Promise.reject(errorHandler(error.response.data)))
}

export {
  uaaLogin,
  uaaFetchStatus,
  uaaLogout,
  uaaPostMFACode,
  uaaResendMFACode,
  uaaCreateAccount,
  uaaResetPassword,
  uaaFetchAuthProviders,
  fetchUserId,
  fetchUserIdForImpersonation,
}
